import { render, staticRenderFns } from "./AiMappingListInstance.vue?vue&type=template&id=0c68557f"
import script from "./AiMappingListInstance.vue?vue&type=script&lang=js"
export * from "./AiMappingListInstance.vue?vue&type=script&lang=js"
import style0 from "./AiMappingListInstance.vue?vue&type=style&index=0&id=0c68557f&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports